export enum Vapor {
  Standard = 0,
  High = 0.5,
  Max = 1,
  Xl = 1.5,
}
